const debugCondition = process.env.CONTEXT !== 'production'

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const logDebugMessage = (...args: any[]) =>
  debugCondition && console.log(...args)

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const errorDebugMessage = (...args: any[]) =>
  debugCondition && console.error(...args)
